import { cn } from "@/lib/utils"
import { BrandIcon } from "@/components/BrandIcon"
import { Wordmark } from "@/components/Wordmark"

interface BrandLockupProps {
  className?: string
  iconSize?: number
  wordmarkClassName?: string
  /** Icon fill: "brand" gradient (default) or "neutral" charcoal. */
  tone?: "brand" | "neutral"
}

// Horizontal brand lockup — icon mark + wordmark. Shared by the sidebar header
// and the auth pages so the two stay visually in sync. The icon is decorative
// (alt=""); the wordmark carries the single accessible name.
export function BrandLockup({
  className,
  iconSize = 20,
  wordmarkClassName = "text-xl",
  tone = "brand",
}: BrandLockupProps) {
  return (
    <div className={cn("inline-flex items-center gap-1.5", className)}>
      <BrandIcon size={iconSize} alt="" tone={tone} />
      <Wordmark className={cn("whitespace-nowrap", wordmarkClassName)} />
    </div>
  )
}
